import styles from './YellowNoteFooter.module.scss';

import DateRangeIcon from '@mui/icons-material/DateRange';
import { Typography } from '@mui/material';
import { DateTime } from 'luxon';

import { PostIt } from '@work4all/models/lib/Classes/PostIt.entity';

import { DateTimeCustom } from '@work4all/utils/lib/date-utils/formatDateString';

import { YellowNoteCornerGraphic } from './YellowNoteCornerGraphic';

type YellowNoteFooter = {
  note?: PostIt;
};

export const YellowNoteFooter = ({ note }: YellowNoteFooter) => {
  if (!note) return null;

  return (
    <div className={styles.footer}>
      <div className={styles.footerContent}>
        <Typography className={styles.footerTextWrapper} variant="caption">
          {note?.date ? <DateRangeIcon /> : null}
          <span className={styles.footerText}>
            {note?.date
              ? DateTime.fromISO(note.date).toLocaleString(
                  DateTimeCustom.DATE_SHORT
                )
              : null}
            {note?.date && note.user ? <span> | </span> : null}
            {note?.user ? note.user.displayName : null}
          </span>
        </Typography>
      </div>

      <div className={styles.footerCorner}>
        <div className={styles.cornerTop} />
        <div className={styles.cornerBottom}>
          <YellowNoteCornerGraphic className={styles.cornerGraphic} />
        </div>
      </div>
    </div>
  );
};
